var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<h3><i class='fa fa-pencil-square-o'></i> <strong>Form</strong> Pembawaan Barang Asal TLDDP</h3>"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-user'></i> Data Pemberitahu"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Lengkap"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.namaPemberitahu),
      expression: "headerTransit.namaPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nama Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.namaPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.namaPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Pemberitahu')),
      expression: "errors.has('Nama Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nama Pemberitahu')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jenisIdPemberitahu),
      expression: "headerTransit.jenisIdPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Identitas Pemberitahu",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.jenisIdPemberitahu = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NPWP"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KTP"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Paspor"
    }
  }, [_vm._v("Paspor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lainnya"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Identitas Pemberitahu')),
      expression: "errors.has('Jenis Identitas Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Identitas Pemberitahu')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.idPemberitahu),
      expression: "headerTransit.idPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.headerTransit.jenisIdPemberitahu === 'NPWP' ? 'required|min:16' : 'required'),
      expression: "headerTransit.jenisIdPemberitahu === 'NPWP' ? 'required|min:16' : 'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Identitas Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.idPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.idPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas Pemberitahu')),
      expression: "errors.has('Nomor Identitas Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas Pemberitahu')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.alamatPemberitahu),
      expression: "headerTransit.alamatPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Alamat Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.alamatPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.alamatPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat Pemberitahu')),
      expression: "errors.has('Alamat Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Alamat Pemberitahu')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pekerjaan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pekerjaanPemberitahu),
      expression: "headerTransit.pekerjaanPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Pekerjaan Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.pekerjaanPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.pekerjaanPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pekerjaan Pemberitahu')),
      expression: "errors.has('Pekerjaan Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pekerjaan Pemberitahu')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Telepon"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.noTelpPemberitahu),
      expression: "headerTransit.noTelpPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Telepon Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.noTelpPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.noTelpPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Telepon Pemberitahu')),
      expression: "errors.has('Nomor Telepon Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Telepon Pemberitahu')))])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-user'></i> Data Sponsor"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Lengkap"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.namaSponsor),
      expression: "headerTransit.namaSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nama Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.namaSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.namaSponsor = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jenisIdSponsor),
      expression: "headerTransit.jenisIdSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Identitas Sponsor",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.jenisIdSponsor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NPWP"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KTP"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Paspor"
    }
  }, [_vm._v("Paspor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lainnya"
    }
  }, [_vm._v("Lainnya")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.idSponsor),
      expression: "headerTransit.idSponsor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.headerTransit.jenisIdSponsor === 'NPWP' ? 'min:16' : ''),
      expression: "headerTransit.jenisIdSponsor === 'NPWP' ? 'min:16' : ''"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Identitas Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.idSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.idSponsor = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas Sponsor')),
      expression: "errors.has('Nomor Identitas Sponsor')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas Sponsor')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.alamatSponsor),
      expression: "headerTransit.alamatSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Alamat Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.alamatSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.alamatSponsor = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pekerjaan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pekerjaanSponsor),
      expression: "headerTransit.pekerjaanSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Pekerjaan Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.pekerjaanSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.pekerjaanSponsor = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Telepon"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.noTelpSponsor),
      expression: "headerTransit.noTelpSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Telepon Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.noTelpSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.noTelpSponsor = $event.target.value
      }
    }
  })])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-archive'></i> Data Penggunaan Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Pemasukan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jenisPemasukan),
      expression: "headerTransit.jenisPemasukan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Pemasukan",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.jenisPemasukan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Barang Bawaan Penumpang"
    }
  }, [_vm._v("Melalui Kawasan Bebas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Barang Awak Sarana Pengangkut"
    }
  }, [_vm._v("Sementara")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Pemasukan')),
      expression: "errors.has('Jenis Pemasukan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Pemasukan')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tujuan Pemasukan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.tujuanPemasukan),
      expression: "headerTransit.tujuanPemasukan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tujuan Pemasukan",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.tujuanPemasukan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transit"
    }
  }, [_vm._v("Transit")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Perbaikan/rekondisi/pengujian/kalibrasi"
    }
  }, [_vm._v("Perbaikan/rekondisi/pengujian/kalibrasi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Sewa menyewa"
    }
  }, [_vm._v("Sewa menyewa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pameran/peragaan/demonstrasi"
    }
  }, [_vm._v("Pameran/peragaan/demonstrasi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pertunjukan umum/olah raga/perlombaan"
    }
  }, [_vm._v("Pertunjukan umum/olah raga/perlombaan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Keperluan contoh/model"
    }
  }, [_vm._v("Keperluan contoh/model")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Keperluan profesional/tenaga ahli"
    }
  }, [_vm._v("Keperluan profesional/tenaga ahli")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lainnya"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tujuan Pemasukan')),
      expression: "errors.has('Tujuan Pemasukan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Tujuan Pemasukan')))])])], 1)]), _vm._v(" "), (_vm.headerTransit.tujuanPemasukan == 'Lainnya') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tujuan Pemasukan Lainnya"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.tujuanPemasukanLainnya),
      expression: "headerTransit.tujuanPemasukanLainnya"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.headerTransit.tujuanPemasukanLainnya)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.tujuanPemasukanLainnya = $event.target.value
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Lokasi Penggunaan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.lokasiPenggunaan),
      expression: "headerTransit.lokasiPenggunaan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Lokasi Penggunaan"
    },
    domProps: {
      "value": (_vm.headerTransit.lokasiPenggunaan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.lokasiPenggunaan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Lokasi Penggunaan')),
      expression: "errors.has('Lokasi Penggunaan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Lokasi Penggunaan')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Asal Barang"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.asalBarang),
      expression: "headerTransit.asalBarang"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Asal Barang",
      "placeholder": "Contoh: Surabaya"
    },
    domProps: {
      "value": (_vm.headerTransit.asalBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.asalBarang = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Asal Barang')),
      expression: "errors.has('Asal Barang')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Asal Barang')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Perkiraan Tanggal Keluar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.perkiraanTanggalKeluar),
      expression: "headerTransit.perkiraanTanggalKeluar"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "Perkiraan Tanggal Keluar"
    },
    domProps: {
      "value": (_vm.headerTransit.perkiraanTanggalKeluar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.perkiraanTanggalKeluar = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Perkiraan Tanggal Keluar')),
      expression: "errors.has('Perkiraan Tanggal Keluar')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Perkiraan Tanggal Keluar')))])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-plane'></i> Data Pengangkut"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Sarana Pengangkut"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.refSarkut,
      "option-value": "nama_sarkut",
      "option-text": "nama_sarkut",
      "placeholder": "-- Pilih Nama Sarana Pengangkut --"
    },
    model: {
      value: (_vm.headerTransit.namaSarkut),
      callback: function($$v) {
        _vm.headerTransit.namaSarkut = $$v
      },
      expression: "headerTransit.namaSarkut"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Sarana Pengangkut')),
      expression: "errors.has('Nama Sarana Pengangkut')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nama Sarana Pengangkut')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Sarana Pengangkut"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.nomorSarkut),
      expression: "headerTransit.nomorSarkut"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Sarana Pengangkut"
    },
    domProps: {
      "value": (_vm.headerTransit.nomorSarkut)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.nomorSarkut = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Sarana Pengangkut')),
      expression: "errors.has('Nomor Sarana Pengangkut')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Sarana Pengangkut')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Masuk"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pelMasuk),
      expression: "headerTransit.pelMasuk"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Pelabuhan Masuk",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.pelMasuk = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batu Ampar"
    }
  }, [_vm._v("Batu Ampar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Warehouse Hang Nadim"
    }
  }, [_vm._v("Warehouse Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminal Hang Nadim"
    }
  }, [_vm._v("Terminal Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Telaga Punggur"
    }
  }, [_vm._v("Telaga Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Roro Punggur"
    }
  }, [_vm._v("Roro Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Domestik Sekupang"
    }
  }, [_vm._v("Domestik Sekupang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Harbour Bay"
    }
  }, [_vm._v("Harbour Bay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nongsa Pura"
    }
  }, [_vm._v("Nongsa Pura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batam Center"
    }
  }, [_vm._v("Batam Center")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pelabuhan Masuk')),
      expression: "errors.has('Pelabuhan Masuk')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pelabuhan Masuk')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Keluar"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pelKeluar),
      expression: "headerTransit.pelKeluar"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Pelabuhan Keluar",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.pelKeluar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batu Ampar"
    }
  }, [_vm._v("Batu Ampar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Warehouse Hang Nadim"
    }
  }, [_vm._v("Warehouse Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminal Hang Nadim"
    }
  }, [_vm._v("Terminal Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Telaga Punggur"
    }
  }, [_vm._v("Telaga Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Roro Punggur"
    }
  }, [_vm._v("Roro Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Domestik Sekupang"
    }
  }, [_vm._v("Domestik Sekupang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Harbour Bay"
    }
  }, [_vm._v("Harbour Bay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nongsa Pura"
    }
  }, [_vm._v("Nongsa Pura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batam Center"
    }
  }, [_vm._v("Batam Center")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pelabuhan Keluar')),
      expression: "errors.has('Pelabuhan Keluar')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pelabuhan Keluar')) + "\">")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Kedatangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.tanggalDatang),
      expression: "headerTransit.tanggalDatang"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "Tanggal Kedatangan"
    },
    domProps: {
      "value": (_vm.headerTransit.tanggalDatang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.tanggalDatang = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal Kedatangan')),
      expression: "errors.has('Tanggal Kedatangan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Tanggal Kedatangan')) + "\">")])])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Dokumen Pendukung"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v("List Dokumen Pendukung")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteAllDokumen
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" Delete All")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-dokumen",
      modifiers: {
        "collapse-add-dokumen": true
      }
    }],
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4 mx-2"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Jenis Dokumen")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Nomor Dokumen")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Tanggal Dokumen")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": ""
    }
  }, [_vm._v("Aksi/Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.headerTransit.tableDokung), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jenisDokumen))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.nomorDokumen))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tanggalDokumen))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteDokung(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "edit"
      },
      on: {
        "click": function($event) {
          _vm.editDokung(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])])])
  }))])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mx-2",
    attrs: {
      "id": "collapse-add-dokumen"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-edit'></i> Tambah Dokumen Pendukung"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen Pendukung"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailDokung.jenisDokumen),
      expression: "detailDokung.jenisDokumen"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Dokumen Pendukung",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.detailDokung.jenisDokumen = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Invoice"
    }
  }, [_vm._v("Invoice")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Packing List"
    }
  }, [_vm._v("Packing List")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Purchase Order"
    }
  }, [_vm._v("Purchase Order")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kontrak"
    }
  }, [_vm._v("Kontrak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Flyer"
    }
  }, [_vm._v("Flyer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lainnya"
    }
  }, [_vm._v("Lainnya")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Dokumen"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailDokung.nomorDokumen),
      expression: "detailDokung.nomorDokumen"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailDokung.nomorDokumen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailDokung.nomorDokumen = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Dokumen"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailDokung.tanggalDokumen),
      expression: "detailDokung.tanggalDokumen"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.detailDokung.tanggalDokumen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailDokung.tanggalDokumen = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-dokumen",
      modifiers: {
        "collapse-add-dokumen": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submitDokung
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-dokumen",
      modifiers: {
        "collapse-add-dokumen": true
      }
    }],
    staticClass: "btn btn-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])])])])], 1), _vm._v(" "), _vm._l((_vm.headerTransit.tableDokung), function(data, index) {
    return _c('b-collapse', {
      key: index,
      ref: ("collapse-edit-dokumen " + index),
      refInFor: true,
      staticClass: "mx-2",
      attrs: {
        "id": ("collapse-edit-dokumen " + index)
      }
    }, [_c('b-card', {
      attrs: {
        "header": ("<i class='fa fa-edit'></i> Edit Dokumen Pendukung " + (index+1))
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Jenis Dokumen Pendukung"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editedDokung.jenisDokumen),
        expression: "editedDokung.jenisDokumen"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "Jenis Dokumen Pendukung"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.editedDokung.jenisDokumen = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Invoice"
      }
    }, [_vm._v("Invoice")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Packing List"
      }
    }, [_vm._v("Packing List")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Purchase Order"
      }
    }, [_vm._v("Purchase Order")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Kontrak"
      }
    }, [_vm._v("Kontrak")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Flyer"
      }
    }, [_vm._v("Flyer")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Lainnya"
      }
    }, [_vm._v("Lainnya")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nomor Dokumen"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editedDokung.nomorDokumen),
        expression: "editedDokung.nomorDokumen"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.editedDokung.nomorDokumen)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editedDokung.nomorDokumen = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Tanggal Dokumen"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editedDokung.tanggalDokumen),
        expression: "editedDokung.tanggalDokumen"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (_vm.editedDokung.tanggalDokumen)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editedDokung.tanggalDokumen = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row mt-2"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-dokumen " + index)),
        expression: "`collapse-edit-dokumen ${index}`"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.saveEditDokung(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save"
    }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-dokumen " + index)),
        expression: "`collapse-edit-dokumen ${index}`"
      }],
      staticClass: "btn btn-danger"
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Cancel")])])])])])], 1)
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-archive'></i> Data Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v("List Data Barang")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteAllGood
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" Delete All")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-barang",
      modifiers: {
        "collapse-add-barang": true
      }
    }],
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 mx-2"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%",
      "scope": "col"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "",
      "scope": "col"
    }
  }, [_vm._v("Uraian Barang / "), _c('i', [_vm._v("Description of Goods")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("Type/Merk / "), _c('i', [_vm._v("Type/Brand")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("Harga / "), _c('i', [_vm._v("Price")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("No. Seri / "), _c('i', [_vm._v("Serial Number")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%",
      "scope": "col"
    }
  }, [_vm._v("Jumlah / "), _c('i', [_vm._v("Amount")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%",
      "scope": "col"
    }
  }, [_vm._v("Keterangan / "), _c('i', [_vm._v("information")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "9%",
      "scope": "col"
    }
  }, [_vm._v("Aksi / "), _c('i', [_vm._v("Action")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.headerTransit.tableDetail), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.uraianBarang) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.typeMerk) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.harga) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.noSeri) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.jumlahBarang) + " " + _vm._s(data.satuanBarang) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.keterangan) + " ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteGood(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-barang " + index)),
        expression: "`collapse-edit-barang ${index}`"
      }],
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "edit"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])])])
  }))])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mx-2",
    attrs: {
      "id": "collapse-add-barang"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-edit'></i> Tambah Data Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Uraian Barang"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.uraianBarang),
      expression: "detailTransit.uraianBarang"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailTransit.uraianBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.uraianBarang = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Type/Merk"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.typeMerk),
      expression: "detailTransit.typeMerk"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailTransit.typeMerk)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.typeMerk = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Harga"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.harga),
      expression: "detailTransit.harga"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.detailTransit.harga)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.harga = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Seri"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.noSeri),
      expression: "detailTransit.noSeri"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailTransit.noSeri)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.noSeri = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Barang"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.jumlahBarang),
      expression: "detailTransit.jumlahBarang"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.detailTransit.jumlahBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.jumlahBarang = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Satuan Barang"
    }
  }, [_c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "list": _vm.formattedJenisSatuan,
      "option-value": "value",
      "option-text": "text"
    },
    model: {
      value: (_vm.detailTransit.satuanBarang),
      callback: function($$v) {
        _vm.detailTransit.satuanBarang = $$v
      },
      expression: "detailTransit.satuanBarang"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.keterangan),
      expression: "detailTransit.keterangan"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailTransit.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.keterangan = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-barang",
      modifiers: {
        "collapse-add-barang": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submitGoods
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-barang",
      modifiers: {
        "collapse-add-barang": true
      }
    }],
    staticClass: "btn btn-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])])])])], 1), _vm._v(" "), _vm._l((_vm.headerTransit.tableDetail), function(data, index) {
    return _c('b-collapse', {
      key: index,
      staticClass: "mt-2",
      attrs: {
        "id": ("collapse-edit-barang " + index)
      }
    }, [_c('b-card', {
      attrs: {
        "header": ("<i class='fa fa-edit'></i> Edit Barang " + (index+1) + " ")
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Uraian Barang"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.uraianBarang),
        expression: "detailTransit.uraianBarang"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.uraianBarang
      },
      domProps: {
        "value": (_vm.detailTransit.uraianBarang)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.uraianBarang = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Type / Merk"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.typeMerk),
        expression: "detailTransit.typeMerk"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.typeMerk
      },
      domProps: {
        "value": (_vm.detailTransit.typeMerk)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.typeMerk = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Harga"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.harga),
        expression: "detailTransit.harga"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.harga,
        "min": "0",
        "type": "number"
      },
      domProps: {
        "value": (_vm.detailTransit.harga)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.harga = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row mt-3"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nomor Seri"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.noSeri),
        expression: "detailTransit.noSeri"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.noSeri
      },
      domProps: {
        "value": (_vm.detailTransit.noSeri)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.noSeri = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Jumlah Barang"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.jumlahBarang),
        expression: "detailTransit.jumlahBarang"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.jumlahBarang
      },
      domProps: {
        "value": (_vm.detailTransit.jumlahBarang)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.jumlahBarang = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Satuan Barang"
      }
    }, [_c('model-list-select', {
      staticClass: "form-control",
      attrs: {
        "list": _vm.formattedJenisSatuan,
        "option-value": "value",
        "option-text": "text",
        "placeholder": data.satuanBarang
      },
      model: {
        value: (_vm.detailTransit.satuanBarang),
        callback: function($$v) {
          _vm.detailTransit.satuanBarang = $$v
        },
        expression: "detailTransit.satuanBarang"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Keterangan"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.keterangan),
        expression: "detailTransit.keterangan"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.keterangan,
        "type": "text"
      },
      domProps: {
        "value": (_vm.detailTransit.keterangan)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.keterangan = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 pull-right"
    }, [_c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-barang " + index)),
        expression: "`collapse-edit-barang ${index}`"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.saveEditBarang(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save"
    }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-barang " + index)),
        expression: "`collapse-edit-barang ${index}`"
      }],
      staticClass: "btn btn-danger"
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Cancel")])])])], 1)
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": '/login'
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg pull-right",
    on: {
      "click": _vm.cekSubmitAll
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v("\n                        Send")])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Persetujuan"
    },
    on: {
      "ok": function($event) {
        _vm.modalPersetujuan = false
      }
    },
    model: {
      value: (_vm.modalPersetujuan),
      callback: function($$v) {
        _vm.modalPersetujuan = $$v
      },
      expression: "modalPersetujuan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n                        Saya menyatakan bahwa data yang disampaikan adalah benar\n                        dan saya bertanggung jawab atas kebenaran data/dokumen yang disampaikan\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block btn-lg",
    on: {
      "click": function($event) {
        _vm.submitAll()
      }
    }
  }, [_vm._v("Kirim")])])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75585bb6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/transit/FormTransitNew.vue
// module id = 390
// module chunks = 0